'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _iBem2 = _interopRequireDefault(_iBem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.declMod)({ border: 'transparent' }, {
    block: 'header2',
    content: function content() {
        return [this.__base.apply(this, arguments), _react2.default.createElement(_iBem2.default, { block: this.block, elem: 'white-stripe', key: 'white-stripe' })];
    }
});